export enum ModularStoreSetupSteps {
  ADDRESS_INFORMATION = "address_information",
  CERTIFICATE = "certificate",
  PHONE_AND_STATE = "phone_and_state",
  COMPLETE = "complete",
  STUDENT_IDENTIFICATION = "student_identification",
}
